module.exports = __webpack_public_path__ + "static/8-91a06d1f30e0cdbacecb4e282278d276.jpg";